import type { FaireProductEntity } from "../../entity_types/product";

export const p_45mt9pkb86: FaireProductEntity = {
  token: "p_45mt9pkb86",
  type: "product",
  name: "Arkansas, Football, Game Day, Tailgate Party State Tshirt",
  brandToken: "b_23opayswai",
  brandName: "Refinery Number One LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/071ae44ada4be448959b44ba33a6d612202a9edb05ca8a53a988c7fcc9a67ecc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2e8eeee3caf0df3b913eabcc3753df0fbdba0f8d7842db6b0782f8f141b05f21.jpeg",
    "https://cdn.faire.com/fastly/5be3d10d65bb5aebd1273fd0555904b83bb788dbac86c27cab63be4c294e46f2.jpeg",
    "https://cdn.faire.com/fastly/71e622f8e46ad4bd69a382594f3e33a0e15a85523c0e9d1868afc0f49666427c.jpeg",
    "https://cdn.faire.com/fastly/83bace3192040e9adfa4f37339403705ff798389b9b554058de84df19eb741e7.jpeg",
    "https://cdn.faire.com/fastly/b2583ca9fedba5e5c06e1b8b94e4fb219d8861991be42386cb0227145b3eb68c.jpeg",
    "https://cdn.faire.com/fastly/3eac33f7608e61021d47cfb3ea3cabc83616b6617be004739872a025a739ac05.jpeg",
    "https://cdn.faire.com/fastly/e5a765e7a3b983d00f08f58c88e180ceb09e7c1e3a8a363d492123157ffdfbaa.jpeg",
    "https://cdn.faire.com/fastly/72e1ea26090a042de73bf835bfe902d1226f07bf3a8c601af25229936d05dfe9.jpeg",
    "https://cdn.faire.com/fastly/4236a45bdc7eb12165284802eae793192a73f9df9460769619f640c226488b02.jpeg",
  ],
  priceDollars: 19.99,
  description:
    "Our state-of-the-art printing technique creates a soft design that won't crack and is soft to the touch. Details: We use Comfort Colors 1717 soft cotton garment dyed t-shirts, they are made with premium quality knit cotton jersey. A modern unisex fitted shirt, this style features a crewneck and contoured sides for a stylish trendy t-shirt. Made with pre-shrunk 100% combed ring-spun cotton. All of our tees are made using state-of-the-art, water-based, direct-to-film inks. Printed designs are lightweight and sit atop the fabric for a soft touch feel. Sizing Guide: Women: Order your normal size for a casual fit. Size down for a more fitted look. Men: If you are in-between sizes, we suggest sizing up. For exact measurements, see the size guide in the images.",
  tags: [],
  msrpDollars: 36.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:24:22.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
